import React from 'react';
import { Chip } from '@mui/material';

const STATUS_CONFIG = {
  active: { label: 'Activo', color: 'success', variant: 'outlined' },
  cancelled: { label: 'Anulado', color: 'error', variant: 'outlined' },
  partial: { label: 'Mixto', color: 'warning', variant: 'outlined' },
  attached: { label: 'Adjuntado', color: 'success', variant: 'outlined' },
  pending: { label: 'Pendiente', color: 'warning', variant: 'outlined' },
  incomplete: { label: 'Incompleto', color: 'warning', variant: 'filled' },
  none: { label: 'Sin estado', color: 'default', variant: 'outlined' },
};

export default function PaymentStatusChip({ status, value, label, size = 'small' }) {
  const raw = status?.value || value || status || 'none';
  const key = String(raw).toLowerCase();
  const config = STATUS_CONFIG[key] || STATUS_CONFIG.none;

  return (
    <Chip
      size={size}
      color={config.color}
      variant={config.variant}
      label={status?.label || label || config.label}
      sx={{ fontWeight: 500 }}
    />
  );
}
